export default __webpack_public_path__ + "static/media/about.a3bfddf2.jpg";